import React from 'react';
import './full-screen-carousel-item.scss';
import { setInterval } from 'timers';
import { ThinkPeaks } from 'styled-icons/fa-brands';
import { fireAnalytics, getQualityFlag, getMuteFlag } from '../../pages/utils';

export default class Artwork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork,
      showLoader: true,
      mute: getMuteFlag(),
      highquality: getQualityFlag(),
      isCurrent: props.isCurrent,
      downloadInfo: false,
      posterImage: true,
    };
    this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkVideoUrl = this.getArtworkVideoUrl.bind(this);
    // this.handleConnectionChangePlayer = this.handleConnectionChangePlayer.bind(this);
    this.prevURL = 'null';
    this.downloadVideoTimeout = 'null';
    this.listDownloadedFilesTimeout = 'null';
    this.downloadInfoText = '';
    this.videoName = 0;
    this.downloadVideo = false;
    this.checkDownloadVideoTimeout = null;
    this.currentlyPlayingArtwork = '';
    this.downloadedVideoArray = [];
    this.startDownload = true;
    this.downloadQueue = [];
    this.downloadHighQuality = false;
    this.isUSB = false;
    this.isSpace = false;
    this.isPlayingOffline = false;
  }

  rotationCheck = () => {
    console.log('here is rotation check');
    setTimeout(() => {
      const _artwork = this.state.artwork;
      console.log(
        'Ratio : ',
        window.innerWidth,
        window.innerHeight,
        _artwork.orientation,
        _artwork.sourceFile.metadata.aspectRatio
      );
      const video = document.getElementById('video');
      const poster = document.getElementById('poster');
      if (window.innerWidth > window.innerHeight) {
        if (_artwork.sourceFile.metadata.aspectRatio === '9:16') {
          poster.classList.add('ImageRotated');
          video.classList.add('ImageRotated');
        } else if (_artwork.sourceFile.metadata.aspectRatio === '1:1') {
          poster.classList.remove('ImageRotated');
          video.classList.remove('ImageRotated');
          video.style.objectFit = 'contain';
          poster.style.objectFit = 'contain';
        } else if (_artwork.orientation === 'portrait') {
          poster.classList.add('ImageRotated');
        } else {
          poster.classList.remove('VideoRotated');
          video.classList.remove('VideoRotated');
          poster.classList.remove('ImageRotated');
          video.classList.remove('ImageRotated');
          video.style.objectFit = 'cover';
        }
      } else if (_artwork.sourceFile.metadata.aspectRatio === '1:1') {
        poster.classList.remove('ImageRotated');
        video.classList.remove('ImageRotated');
        video.style.objectFit = 'contain';
        poster.style.objectFit = 'contain';
      } else if (_artwork.sourceFile.metadata.aspectRatio === '9:16') {
        poster.classList.remove('VideoRotated');
        video.classList.remove('VideoRotated');
        video.style.objectFit = 'cover';
        poster.style.objectFit = 'cover';
      } else if (_artwork.sourceFile.metadata.aspectRatio === '16:9' && _artwork.orientation !== 'portrait') {
        poster.classList.add('VideoRotated');
        video.classList.add('VideoRotated');
        video.style.objectFit = 'cover';
        poster.style.objectFit = 'cover';
      } else if (_artwork.sourceFile.metadata.aspectRatio === '16:9' && _artwork.orientation === 'portrait') {
        poster.classList.remove('VideoRotated');
        video.classList.add('VideoRotated');
        video.style.objectFit = 'cover';
        poster.style.objectFit = 'cover';
      }
    }, 100);
  };

  componentDidMount() {
    window.screen.orientation.addEventListener('change', this.rotationCheck);

    const video = document.getElementById('video');
    const poster = document.getElementById('poster');
    this.rotationCheck();
    // const poster = document.getElementById('poster');
    // setTimeout(() => {
    //   if (this.props.artwork.orientation === 'portrait' && window.innerWidth > window.innerHeight) {
    //     poster.classList.add("ImageRotated");
    //   } else if (this.props.artwork.orientation === 'portrait') {
    //     poster.classList.remove("VideoRotated");
    //     poster.classList.remove("ImageRotated");
    //   } else {
    //     poster.classList.remove("ImageRotated");
    //   }
    // }, 400);
    if (window.screen.width * window.devicePixelRatio > 1920) this.downloadHighQuality = true;
    // this.getUSBInformation();
    this.interval = setInterval(() => {
      if (this.state.mute != getMuteFlag() && this.props.isCurrent) {
        this.setState({
          mute: getMuteFlag(),
        });
      }
    }, 4000);
    // const video = document.getElementById('video');
    // video.onwaiting = () => {
    //   this.setState({ showLoader: true, isCurrent: true });
    // };
    video.onplaying = () => {
      console.log(video.videoWidth, video.videoHeight, this.state.artwork.orientation);
      // if(video.videoWidth === video.videoHeight) {
      //   document.getElementById("poster").style.objectFit = "contain";
      //   document.getElementsByTagName('video')[0].style.objectFit = "contain";
      // } else {
      //   document.getElementById("poster").style.objectFit = "cover";
      //   document.getElementsByTagName('video')[0].style.objectFit = "cover";
      // }
      // if ((window.innerWidth <= window.innerHeight) && (video.videoWidth > video.videoHeight)) {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.add("VideoRotated");
      // } else if ((window.innerWidth >= window.innerHeight) && (video.videoWidth < video.videoHeight)) {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.add("VideoRotated");
      // } else {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.remove("VideoRotated");
      // }
      setTimeout(() => {
        this.setState({ posterImage: false });
      }, 2000);
    };

    if (localStorage.getItem('OfflineURL') !== null) {
      this.downloadedVideoArray.push(localStorage.getItem('OfflineURL').toString().split('.')[0]);
    }

    // window.addEventListener('online', this.handleConnectionChangePlayer);
    // window.addEventListener('offline', this.handleConnectionChangePlayer);
  }

  // handleConnectionChangePlayer(event) {
  //   if (event.type == "offline") {
  //     // clearInterval(this.interval);
  //     this.checkDownloadVideoTimeout = setTimeout(() => {
  //       if (!this.downloadVideo)
  //         this.checkFile();
  //     }, 10000);
  //   }
  //   if (event.type == "online") {
  //     if (this.downloadQueue.length > 0) {
  //       this.downloadQueue.shift();
  //     }
  //     this.startDownload = true;
  //     clearTimeout(this.checkDownloadVideoTimeout);
  //   }
  // }

  // getUSBInformation() {
  //   console.log("Inside Check USB Info");
  //   const that = this;
  //   function successCb(cbObject) {
  //     if (cbObject.usbList.length >= 1) that.isUSB = true;
  //     that.checkSpace();
  //   }

  //   function failureCb(cbObject) {
  //     var errorText = cbObject.errorText;
  //     console.log("Error Code [" + errorCode + "]: " + errorText);
  //   }

  //   var storage = new Storage();
  //   storage.getUSBInfo(successCb, failureCb);
  // }

  checkSpace() {
    console.log('Inside Storage Check');
    const that = this;
    const successCb = function (cbObject) {
      const { free } = cbObject;
      const externals = cbObject.externalMemory;
      if (free > 500000 && !that.isUSB) {
        console.log('Space Available');
        that.isSpace = true;
      } else if (!that.isUSB) {
        console.log('Space Not Available, Deleting First Video');
        that.listDownloadedFiles('', 'delete');
      }

      for (const uri in externals) {
        const external = externals[uri];
        if (external.free > 500000) that.isSpace = true;
        else that.listDownloadedFiles('', 'delete');
      }
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };

    const storage = new Storage();
    storage.getStorageInfo(successCb, failureCb);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.screen.orientation.removeEventListener('change', () => {});
  }

  getArtworkUrl(artwork) {
    if (
      artwork &&
      artwork.media &&
      artwork.media.image &&
      artwork.media.image.low &&
      artwork.media.image.low.landscape
    ) {
      return artwork.media.image.low.landscape || artwork.media.image.low;
    }
    return '';
  }

  listDownloadedFiles(fileName, type) {
    console.log('Inside List Files', fileName);
    const that = this;
    let offlineURL = '';
    const successCb = function (cbObject) {
      const { files } = cbObject;
      if (type === 'delete') {
        that.deleteFile(files[0].name);
      }
      for (let i = 0; i < files.length; ++i) {
        const fileInfo = files[i];
        if (fileInfo.name === `${fileName}.mp4`) {
          console.log('Playing from already downloaded');
          that.isPlayingOffline = true;
          clearTimeout(that.downloadVideoTimeout);
          if (that.isUSB) offlineURL = `http://127.0.0.1:9080/external/usb/1/list/me/${fileName}.mp4`;
          else offlineURL = `http://127.0.0.1:9080/Blackdove/${fileName}.mp4`;
          that.setState({ posterImage: true });
          localStorage.setItem('DownloadInfo', 'Downloaded');
          const video = document.getElementById('video');
          video.pause();
          video.src = offlineURL;
          video.load();
          video.play();
          that.downloadVideo = true;
          that.startDownload = true;
        }
      }
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };
    let listOption;
    // List files in the internal memory
    if (!this.isUSB) {
      listOption = {
        path: 'file://internal/Blackdove/',
      };
    } else {
      // List files in the mass storage device in USB port 1.
      listOption = {
        path: 'file://usb:1/list/me',
      };
    }

    const storage = new Storage();
    storage.listFiles(successCb, failureCb, listOption);
  }

  getArtworkVideoUrl(artwork) {
    const { isCurrent } = this.props;
    if (isCurrent) {
      let url;
      if (this.downloadHighQuality) url = artwork.media.video.full['4k'].mp4;
      else url = artwork.media.video.full.high.mp4;
      // if (this.prevURL === 'null') {
      //   this.prevURL = url;
      //   this.currentlyPlayingArtwork = url.toString().split("/")[url.toString().split("/").indexOf('mp4') + 1];
      //   this.listDownloadedFilesTimeout = setTimeout(() => {
      //     this.listDownloadedFiles(this.currentlyPlayingArtwork, 'download');
      //   }, 4000);
      //   this.downloadVideoTimeout = setTimeout(() => {
      //     this.isPlayingOffline = false;
      //     if (this.downloadHighQuality) this.downloadFile(artwork.media.video.full['4k'].mp4);
      //     else this.downloadFile(artwork.media.video.full.high.mp4);
      //   }, 15000);
      // } else if (this.prevURL !== url) {
      //   clearTimeout(this.listDownloadedFilesTimeout);
      //   clearTimeout(this.downloadVideoTimeout);
      //   this.prevURL = url;
      //   this.currentlyPlayingArtwork = url.toString().split("/")[url.toString().split("/").indexOf('mp4') + 1];
      //   this.downloadVideo = false;
      //   this.listDownloadedFilesTimeout = setTimeout(() => {
      //     this.listDownloadedFiles(this.currentlyPlayingArtwork, 'download');
      //   }, 4000);
      //   this.downloadVideoTimeout = setTimeout(() => {
      //     this.isPlayingOffline = false;
      //     if (navigator.onLine && this.startDownload) {
      //       if (this.downloadHighQuality) this.downloadFile(artwork.media.video.full['4k'].mp4);
      //       else this.downloadFile(artwork.media.video.full.high.mp4);
      //     } else {
      //       if (this.downloadQueue.length < 1) {
      //         if (this.downloadHighQuality) this.downloadQueue.push(artwork.media.video.full['4k'].mp4);
      //         else this.downloadQueue.push(artwork.media.video.full.high.mp4);
      //       } else {
      //         this.downloadQueue.shift();
      //         if (this.downloadHighQuality) this.downloadQueue.push(artwork.media.video.full['4k'].mp4);
      //         else this.downloadQueue.push(artwork.media.video.full.high.mp4);
      //       }
      //     }
      //   }, 15000);
      // }
      if (this.prevURL !== url && isCurrent) {
        fireAnalytics('PlayVideo', 'Play', url);
      }
      return url;
    }
    return '';
  }

  downloadFile(url) {
    console.log('Starting Download');
    fireAnalytics('Download', 'Video Download Started', url);
    const that = this;
    const fileName = `${url.toString().split('/')[url.toString().split('/').indexOf('mp4') + 1]}.mp4`;
    let offlineURL = '';
    this.startDownload = false;
    const successCb = function () {
      console.log('Download Complete');
      // that.listFilesFromUSB();
      fireAnalytics('Download', 'Download Complete', fileName);
      that.downloadInfoText = 'Download Complete';
      that.setState({ downloadInfo: true });
      setTimeout(() => {
        that.setState({ downloadInfo: false });
      }, 3000);
      if (that.downloadedVideoArray.length < 1) {
        that.downloadedVideoArray.push(fileName.split('.')[0]);
        localStorage.setItem('OfflineURL', fileName);
      } else {
        // if (!that.isUSB) that.fileExists(that.downloadedVideoArray[0]);
        that.downloadedVideoArray.shift();
        that.downloadedVideoArray.push(fileName.split('.')[0]);
        localStorage.setItem('OfflineURL', fileName);
      }
      if (that.currentlyPlayingArtwork === that.downloadedVideoArray[0] && !that.isPlayingOffline) {
        if (that.isUSB) offlineURL = `http://127.0.0.1:9080/external/usb/1/list/me/${that.downloadedVideoArray[0]}.mp4`;
        else offlineURL = `http://127.0.0.1:9080/Blackdove/${that.downloadedVideoArray[0]}.mp4`;
        that.setState({ posterImage: true });
        localStorage.setItem('DownloadInfo', 'Downloaded');
        const video = document.getElementById('video');
        video.pause();
        video.src = offlineURL;
        video.load();
        video.play();
        that.downloadVideo = true;
        that.startDownload = true;
      } else if (that.downloadQueue.length > 0) {
        that.downloadFile(that.downloadQueue[0]);
        that.downloadQueue.shift();
      }
    };

    const failureCb = function (cbObject) {
      localStorage.setItem('DownloadInfo', null);
      that.startDownload = true;
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
      fireAnalytics('Download', 'Failed To Download Video', fileName);
    };
    let downloadPath = 'file://internal/Blackdove/';
    if (this.isUSB) downloadPath = 'file://usb:1/list/me/';
    const options = {
      source: url,
      destination: downloadPath + fileName,
    };
    const g_storage = new Storage();
    g_storage.copyFile(successCb, failureCb, options);
  }

  checkFile() {
    console.log('Inside Check FIle');
    if (this.downloadedVideoArray.length > 0) {
      const that = this;
      const fileName = localStorage.getItem('OfflineURL');
      const successCb = function (cbObject) {
        const { exists } = cbObject;
        console.log('The file exists: ', exists);
        if (exists) {
          if (that.downloadQueue.length > 0) {
            that.downloadQueue.shift();
          }
          that.setState({ posterImage: true });
          const video = document.getElementById('video');
          video.src = `http://127.0.0.1:9080/Blackdove/${fileName}`;
          video.load();
          video.play();
          that.downloadVideo = true;
          that.startDownload = true;
        } else {
          if (that.downloadQueue.length > 0) {
            that.downloadQueue.shift();
          }
          that.props.history.push('/error');
        }
      };

      const failureCb = function (cbObject) {
        const { errorCode } = cbObject;
        const { errorText } = cbObject;
        console.log(` Error Code [${errorCode}]: ${errorText}`);
      };

      const options = {
        path: `file://internal/Blackdove/${fileName}`,
      };
      const g_storage = new Storage();
      g_storage.exists(successCb, failureCb, options);
    } else {
      this.downloadInfoText = 'No Offline Video Available';
      this.setState({ downloadInfo: true });
      if (this.downloadQueue.length > 0) {
        this.downloadQueue.shift();
      }
      setTimeout(() => {
        this.setState({ downloadInfo: false });
        this.props.history.push('/error');
      }, 3000);
    }
  }

  fileExists(fileName) {
    console.log('Inside File Exists');
    const that = this;
    const successCb = function (cbObject) {
      const { exists } = cbObject;
      console.log('The file exists: ', exists);
      if (exists) {
        that.deleteFile(fileName);
      }
    };
    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };

    const options = {
      path: `file://internal/Blackdove/${fileName}`,
    };
    const g_storage = new Storage();
    g_storage.exists(successCb, failureCb, options);
  }

  deleteFile(fileName) {
    console.log('Inside delete File', fileName);
    const that = this;
    const successCb = function () {
      console.log('Removed File');
      that.checkSpace();
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };
    let options;
    if (!this.isUSB) {
      options = {
        file: `file://internal/Blackdove/${fileName}`,
      };
    } else {
      // List files in the mass storage device in USB port 1.
      options = {
        file: `file://usb:1/list/me${fileName}`,
      };
    }
    // var options = {
    //   file: 'file://internal/Blackdove/' + fileName,
    // };

    const storage = new Storage();
    storage.removeFile(successCb, failureCb, options);
  }

  componentWillReceiveProps({ artwork }) {
    if (artwork.id !== this.state.artwork.id) {
      // console.log("Ratio : ", window.innerWidth, window.innerHeight, artwork.orientation, artwork.sourceFile.metadata.aspectRatio);
      // this.getUSBInformation();
      this.setState({ artwork });
      this.setState({ posterImage: true });
      // const poster = document.getElementById('poster');
      // if (this.state.artwork.orientation === 'portrait' && window.innerWidth > window.innerHeight) {
      //   poster.classList.add("ImageRotated");
      // } else if (this.state.artwork.orientation === 'portrait') {
      //   poster.classList.remove("ImageRotated");
      //   poster.classList.remove("VideoRotated");
      // } else {
      //   poster.classList.remove("ImageRotated");
      // }
      const video = document.getElementById('video');
      const poster = document.getElementById('poster');
      if (artwork.sourceFile !== null) {
        this.rotationCheck();
        // if (window.innerWidth > window.innerHeight) {
        //   if (artwork.sourceFile.metadata.aspectRatio === '9:16') {
        //     poster.classList.add('ImageRotated');
        //     video.classList.add('ImageRotated');
        //   } else if (artwork.sourceFile.metadata.aspectRatio === "1:1") {
        //     poster.classList.remove("ImageRotated");
        //     video.classList.remove("ImageRotated");
        //     video.style.objectFit = "contain";
        //     poster.style.objectFit = "contain";
        //   } else if (artwork.orientation === 'portrait') {
        //     poster.classList.add('ImageRotated');
        //   } else {
        //     poster.classList.remove('ImageRotated');
        //     video.classList.remove('ImageRotated');
        //     poster.classList.remove('VideoRotated');
        //     video.classList.remove('VideoRotated');
        //     video.style.objectFit = "cover";
        //   }
        // } else {
        //   if (artwork.sourceFile.metadata.aspectRatio === "1:1") {
        //     poster.classList.remove("ImageRotated");
        //     video.classList.remove("ImageRotated");
        //     video.style.objectFit = "contain";
        //     poster.style.objectFit = "contain";
        //   } else if (artwork.sourceFile.metadata.aspectRatio === "9:16") {
        //     poster.classList.remove("VideoRotated");
        //     video.classList.remove("VideoRotated");
        //     video.style.objectFit = "cover";
        //     poster.style.objectFit = "cover";
        //   } else if (artwork.sourceFile.metadata.aspectRatio === "16:9" && artwork.orientation !== 'portrait') {
        //     poster.classList.add("VideoRotated");
        //     video.classList.add("VideoRotated");
        //     video.style.objectFit = "cover";
        //     poster.style.objectFit = "cover";
        //   } else if (artwork.sourceFile.metadata.aspectRatio === "16:9" && artwork.orientation === 'portrait') {
        //     poster.classList.remove("VideoRotated");
        //     video.classList.add("VideoRotated");
        //     video.style.objectFit = "cover";
        //     poster.style.objectFit = "cover";
        //   }
        // }
      }
    }
  }

  render() {
    const { artwork } = this.state;
    return (
      <div className="full-screen-carousel-item">
        <div
          className="full-screen-carousel-item__image"
          style={
            !this.props.isCurrent && !this.props.nxtPre
              ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` }
              : { background: 'none' }
          }
        >
          <img
            className="poster"
            id="poster"
            src={this.getArtworkUrl(artwork)}
            style={this.state.posterImage ? { opacity: '1' } : { opacity: '0' }}
          />
          {this.state.showLoader && this.state.isCurrent ? (
            <div tabIndex="-1">
              {' '}
              <span className="spinner spinner--small loader" />
            </div>
          ) : null}
          {this.props.isCurrent ? (
            <video
              tabIndex="-1"
              id="video"
              src={this.getArtworkVideoUrl(artwork)}
              muted={!!this.state.mute}
              autoPlay
              loop
              onPlay={() => {
                this.setState({ showLoader: false });
              }}
              texture="true"
            />
          ) : null}
          {/* {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null} */}
        </div>
        <div className="downloadInfo" style={!this.state.downloadInfo ? { opacity: '0' } : { opacity: '1' }}>
          {this.downloadInfoText}
        </div>
      </div>
    );
  }
}
